import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { OptimizationRunStopModel } from "../../models/resources/optimization-run-stop.model";

@Injectable({
  providedIn: 'root',
})
export class OptimizationRunStopService extends AResourceService<OptimizationRunStopModel> {

  constructor() {
    super('/optimization-run-stops', false, ['vehicle','vitabeneEmployee']);
  }

  setOptimizationRunId(id: number) {
    this.setResourceUrl(`/optimization-runs/${id}/optimization-run-stops`);
  }
}
